import { supabase } from "@/integrations/supabase/client";

export interface BrandServiceResponse {
  success: boolean;
  data?: any;
  error?: string;
}

/**
 * Shared service for fetching brand data from Brand.dev API via Supabase Edge Function
 */
export const brandService = {
  /**
   * Fetch brand data for an organization using Brand.dev API
   * @param organizationId - The organization ID to update
   * @returns Promise with success/error status and data
   */
  async fetchBrandData(organizationId: string): Promise<BrandServiceResponse> {
    try {
      console.log("Calling Brand Fetch Edge Function with organizationId:", organizationId);

      const { data, error } = await supabase.functions.invoke(
        "generate-organization-profile",
        {
          body: { organizationId },
        }
      );

      if (error) {
        console.error("Brand Fetch Edge Function error:", error);
        return {
          success: false,
          error: error.message || "Failed to call Brand Fetch service"
        };
      }

      if (!data) {
        console.error("Brand Fetch returned no data");
        return {
          success: false,
          error: "No data returned from Brand Fetch"
        };
      }

      console.log("Brand Fetch successful:", data);
      return {
        success: true,
        data
      };
    } catch (error: any) {
      console.error("Brand Fetch service error:", error);
      return {
        success: false,
        error: error.message || "Unknown error occurred"
      };
    }
  }
}; 